import React, { lazy, Suspense } from 'react';
import { Routes, Route } from 'react-router-dom';
import { useSelector } from 'react-redux';

// Components
import { DummyHeader, Loader, useForceDeviceViewport } from '@triumph/shared';
import { Wrap } from './App.styled';
import ErrorBoundary from './ErrorBoundary';
import { getErrorSelector } from './redux/app/selectors';
import { Init } from './_utility';

// Lazy import components.
const Catalog = lazy(() => import('./pages/catalog'));
const Parts = lazy(() => import('./pages/parts'));

const App = ({ basepath, contentDataSourceId }) => {
  useForceDeviceViewport();
  const error = useSelector(getErrorSelector);

  return (
    <Wrap>
      <ErrorBoundary error={error}>
        <Init basepath={basepath} contentDataSourceId={contentDataSourceId}>
          {process.env.NODE_ENV === 'development' ? <DummyHeader className="header" /> : null}
          <Suspense fallback={<Loader />}>
            <Routes basepath={basepath}>
              <Route path="/" element={<Catalog />} />
              <Route path="/parts/:bikeId/:modelId/:catalogPageId" element={<Parts />} />
              <Route path="/parts/:bikeId/:modelId/:catalogPageId/:product" element={<Parts />} />
            </Routes>
          </Suspense>
        </Init>
      </ErrorBoundary>
    </Wrap>
  );
};

export default App;
